var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponCodeSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-3 {\n        stroke-dasharray: 3;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Coupon Code Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.94,38.8a7.85,7.85,0,0,0,0-2.09L56.29,35a.52.52,0,0,0,.14-.68l-2.07-3.76a.53.53,0,0,0-.65-.25l-2.7,1a8.31,8.31,0,0,0-1.79-1.09l-.34-2.85a.56.56,0,0,0-.53-.47l-4.3-.09a.56.56,0,0,0-.54.45l-.46,2.83a7.8,7.8,0,0,0-1.83,1L38.56,30a.53.53,0,0,0-.66.22l-2.22,3.67a.54.54,0,0,0,.11.69L38,36.38a7.83,7.83,0,0,0,0,2.09l-2.3,1.73a.54.54,0,0,0-.15.69l2.08,3.76a.53.53,0,0,0,.65.25l2.69-1a8.27,8.27,0,0,0,1.8,1.1l.34,2.85a.54.54,0,0,0,.52.46l4.3.09a.54.54,0,0,0,.54-.44l.46-2.84a8.07,8.07,0,0,0,1.84-1l2.65,1.14a.54.54,0,0,0,.66-.22l2.22-3.68a.54.54,0,0,0-.11-.69Zm-8,2.55a3.76,3.76,0,1,1,3.84-3.68A3.76,3.76,0,0,1,45.9,41.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.8,30.55V14.22H3.8v7l.46,0A7.42,7.42,0,1,1,4.26,36C4.1,36,4,36,3.8,36v7H36.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.3,
    y1: 14.59,
    x2: 21.3,
    y2: 42.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28.3,
    y1: 18.37,
    x2: 34.3,
    y2: 18.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.3,
    y1: 18.37,
    x2: 40.8,
    y2: 18.37
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponCodeSettings01);
export default __webpack_public_path__ + "static/media/Coupon_Code_Settings_01.c81ce54e1c72c789722c6e39855089b5.svg";
export { ForwardRef as ReactComponent };